import { AdCampaignStatus } from '@/cowboy/EnumTypes'

const adCampaignHasStarted = adCampaign => {
  return new Date() >= new Date(adCampaign.startDate)
}

const adCampaignHasNotEnded = adCampaign => {
  return new Date() < new Date(adCampaign.endDate)
}

const AdCampaignMixin = {
  methods: {
    $_adCampaignMixin_adCampaignIsActive (adCampaign) {
      return (
        adCampaign.status === AdCampaignStatus.ACTIVE &&
        adCampaignHasStarted(adCampaign) &&
        adCampaignHasNotEnded(adCampaign)
      )
    }
  }
}

export { AdCampaignMixin }
